import { JSX, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { Box } from "../../Layout/Box/Box";

export class DialogFooter extends BaseComponent<IDialogFooterProps, IDialogFooterState>
{
    public render(): JSX.Element
    {
        return (
            <Box>
                {this.props.children}
            </Box>
        );
    }
}

export interface IDialogFooterProps
{
    children: ReactNode;
}

export interface IDialogFooterState { }
